/* eslint-disable react/prop-types */

import { EFeePayee } from "../../../../setup/api/services/contract/models";
import { IContractProps } from "../../models";
import InfoItem from "./infoItem";
import styles from "./styles.module.scss";
import React from "react";

import {
  ADDITIONIAL_INFO,
  CUSTOMER,
  DELIVERY_PERIOd,
  EXAMINATION_PERIOD,
  FEES,
  NO_SHIPMENT_COMPANY,
  PROVIDER,
  SHIPMENT_COMPANY,
  SHIPMENT_METHOD,
} from "../../constants";
import { useTranslation } from "react-i18next";

const AdditionalDetails = ({ contract }: IContractProps) => {
  const { t } = useTranslation();
  const returnFeePayee = (feePayee: EFeePayee) => {
    return feePayee === EFeePayee.CUSTOMER ? CUSTOMER : PROVIDER;
  };

  const getShipmentCompany = () => {
    if (contract?.shippable) {
      return t("lbl_naqel");
    }
    return contract?.shipment?.fee ||
      contract?.metaData?.sellerRequiresShippingInfo
      ? SHIPMENT_COMPANY
      : NO_SHIPMENT_COMPANY;
  };
  return (
    <div className={styles.info_container}>
      <h4>{ADDITIONIAL_INFO}</h4>
      <div className={styles.infoitem_container}>
        <InfoItem
          title={SHIPMENT_METHOD}
          value={getShipmentCompany()}
          image="/assets/images/svg/shipmentInfo.svg"
        />
        {contract?.deliveryInDays && (
          <InfoItem
            title={DELIVERY_PERIOd}
            value={`${contract.deliveryInDays} يوم`}
            image="/assets/images/svg/deliveryInDays.svg"
          />
        )}
        <InfoItem
          title={FEES}
          value={returnFeePayee(contract.feePayee)}
          image="/assets/images/svg/payment.svg"
        />
        {contract?.inspectionPeriod && (
          <InfoItem
            title={EXAMINATION_PERIOD}
            value={`${contract?.inspectionPeriod} يوم`}
            image="/assets/images/svg/examinationTime.svg"
          />
        )}
      </div>
    </div>
  );
};

export default AdditionalDetails;
